import PropTypes from 'prop-types';

import { useTheme } from '@mui/joy';
import moment from 'moment'

import i18n from '@/i18n'

export const EventFlyOut = ({ x, y, datum, dx, dy }) => (
  <>
    <defs>
      <filter id="shadow">
        <feDropShadow dx="0" dy="0" floodOpacity={0.5}  />
      </filter>
    </defs>
    <g>
      {/*<line
        x1={x}
        y1={y}
        x2={x}
        y2={(y * 2.5)}
        stroke="black"
      />*/}
      <circle
        cx={x}
        cy={y}
        r={10}
        strokeWidth={2}
        style={{ fill: 'var(--primary)', stroke: 'white', filter: 'url(#shadow)' }}
      />
      <rect
        x={x}
        y={y}
        width="200"
        dx={dx}
        dy={dy}
        height="100"
        rx="4.5"
        style={{ fill: datum?.object?.colorScheme?.primary?.dark ?? 'white', filter: 'url(#shadow)' }}
      />
      <image
        x={x + 0}
        y={y + 0}
        width={50}
        height={50}
        href={datum?.object?.imageUrl}
        style={{ opacity: 1 }}
      />
      <text
        x={x + 60}
        y={y + 20}
        fontSize="20"
        fontWeight="bold"
        fill={datum?.object?.colorScheme?.primary?.light ?? "currentColor"}
        style={{ opacity: 1 }}
      >
        {datum?.object.name}
      </text> 
      <text
        x={x + 60}
        y={y + 40}
        fontSize="10"
        fill={datum?.object?.colorScheme?.primary?.light ?? "currentColor"}
      >
        {`${datum.action.name} · ${moment(datum.date).format('LL')}`}
      </text> 
    </g>
  </>  
);

EventFlyOut.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  datum: PropTypes.object.isRequired,
  dx: PropTypes.number,
  dy: PropTypes.number
}

export const FlyOut = ({ dataKey='streams', x, y, datum, dx, dy }) => {
  const theme = useTheme()
  const color = theme.palette.primary.solidBg
  return (
    <svg height="79.5%">
      <defs>
        <filter id="shadow" y="-60%" x="-60%" width="200%" height="200%">
          <feDropShadow dx="0" dy="0" floodOpacity={0.5}  />
        </filter>
        <filter id="shadow2" y="-200%" x="-200%" width="500%" height="500%">
          <feDropShadow dx="0" dy="1" floodOpacity={0.2}  />
        </filter>
      </defs>
      <g>
        {<line
          x1={x}
          y1={y}
          x2={x}
          y2={"100%"}
          strokeWidth={"0.5px"}
          stroke={"black"}
        />}
        <circle
          cx={x}
          cy={y}
          r={5} 
          strokeWidth={2}
          style={{ fill: color, stroke: 'white', filter: 'url(#shadow)' }}
        />
        <svg
          x={x + 10}
          y={y - 10}
          dx={dx}
          dy={dy}
        >
          <rect
            width="70"
            height="28"
            rx="4.5"
            style={{ transform: 'translate(5px, 5px)', fill: 'white', filter: 'url(#shadow2)' }}
          />
          <text
            x={12}
            y={16}
            fontSize="6"
            fill="#868C97"
          >
            {`${moment(datum.date).format('LL')}`}
          </text>
          <text
            x={12}
            y={26}
            fontSize="6"
            fontWeight="bold"
            fill="#868C97"
          >
            {`${(datum[dataKey] ?? 0)?.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} ${i18n.t(dataKey)}`}
          </text> 
        </svg>
      </g>
    </svg>  
  );
}

FlyOut.propTypes = {
  dataKey: PropTypes.string,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  datum: PropTypes.object.isRequired,
  dx: PropTypes.number,
  dy: PropTypes.number,
  height: PropTypes.number
}

FlyOut.defaultProps = {
  dataKey: 'streams',
  dx: 0,
  dy: 0,
  height: 100
}